<template>
  <o-upload
    v-model="csvFile"
    :loading="loading"
    :label="label"
    :type="fileType"
    :expanded="expanded"
    @submit="submit"
    @deleteFile="csvFile = null"
  >
    <template #append>
      <slot name="append" />
    </template>
  </o-upload>
</template>

<script>
import OUpload from '@components/Upload.vue'
import { parseCSV } from '@helpers/csv'

export default {
  name: 'ImportCsv',

  components: {
    OUpload,
  },

  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    format: {
      type: Object,
      required: true,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      csvFile: null,
      fileType: 'text/csv, application/vnd.ms-excel',
    }
  },

  methods: {
    submit() {
      const reader = new FileReader()
      reader.onload = () => {
        const data = parseCSV(reader.result)
        const headers = data.shift().map((header) => header.toLowerCase())

        this.$emit('submit', { result: this.formatData(data, headers) })
      }
      reader.readAsText(this.csvFile)

      this.csvFile = null
    },

    formatData(data, headers) {
      const keys = Object.keys(this.format)

      return data.map((values) => {
        let item = {}
        for (let i = 0; i < keys.length; i++) {
          const index = headers.indexOf(this.format[keys[i]].toLowerCase())
          if (index !== -1) {
            item[keys[i]] = values[index]
          }
        }
        return item
      })
    },
  },
}
</script>
